export const environment = {
  environment: 'prod',
  version: '1.0.0',
  production: true,
  baseUrl: 'https://private.bdeo.io',
  loginUrl: 'https://secure.bdeo.io/login',
  evidenceCaptureURL: 'https://selfadjust.bdeo.es',
  additionalsURL: 'https://bodyshop.bdeo.io',
  cookieDomain: '.bdeo.io',
  trackingProjectKey: 'HwotPZM5GB6xd1FP2AlN',
  trackingIngestUrl: 'https://openreplay.backoffice.bdeo.io/ingest'
};
